import { render } from "./CostiRicaviBiglietteriaAereaSottoProgetto.vue?vue&type=template&id=5f289bca&scoped=true&ts=true"
import script from "./CostiRicaviBiglietteriaAereaSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./CostiRicaviBiglietteriaAereaSottoProgetto.vue?vue&type=script&lang=ts"

import "./CostiRicaviBiglietteriaAereaSottoProgetto.vue?vue&type=style&index=0&id=5f289bca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f289bca"]])

export default __exports__